/* eslint-disable */
import type { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AWSDateTime: { input: any; output: any; }
  AWSJSON: { input: any; output: any; }
};

export type CalendarWidget = {
  __typename?: 'CalendarWidget';
  circuitCalendarLink?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  filterList?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  tourId: Scalars['ID']['output'];
  tournamentFilter: Scalars['String']['output'];
  tournaments?: Maybe<Array<Maybe<CalendarWidgetInfo>>>;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type CalendarWidgetInfo = {
  __typename?: 'CalendarWidgetInfo';
  endDate?: Maybe<Scalars['String']['output']>;
  href?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  surface?: Maybe<Scalars['String']['output']>;
  tournamentName?: Maybe<Scalars['String']['output']>;
  tournamentPlace?: Maybe<Scalars['String']['output']>;
  tournamentType?: Maybe<Scalars['String']['output']>;
};

export type CalendarWidgetInfoInput = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  surface?: InputMaybe<Scalars['String']['input']>;
  tournamentName?: InputMaybe<Scalars['String']['input']>;
  tournamentPlace?: InputMaybe<Scalars['String']['input']>;
  tournamentType?: InputMaybe<Scalars['String']['input']>;
};

export type Competition = {
  __typename?: 'Competition';
  competitionId: Scalars['ID']['output'];
  competitionJson?: Maybe<Scalars['AWSJSON']['output']>;
  competitionName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  editorialData?: Maybe<EditorialDataV2>;
  editorialDataId?: Maybe<Scalars['ID']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  tourCalendar?: Maybe<TourCalendar>;
  tourCalendarId: Scalars['ID']['output'];
  tourId: Scalars['ID']['output'];
  tournaments?: Maybe<ModelTournamentConnection>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
};


export type CompetitiontournamentsArgs = {
  filter?: InputMaybe<ModelTournamentFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};

export type CreateCalendarWidgetInput = {
  circuitCalendarLink?: InputMaybe<Scalars['String']['input']>;
  filterList?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tourId: Scalars['ID']['input'];
  tournamentFilter: Scalars['String']['input'];
  tournaments?: InputMaybe<Array<InputMaybe<CalendarWidgetInfoInput>>>;
};

export type CreateCompetitionInput = {
  competitionId: Scalars['ID']['input'];
  competitionJson?: InputMaybe<Scalars['AWSJSON']['input']>;
  competitionName?: InputMaybe<Scalars['String']['input']>;
  editorialDataId?: InputMaybe<Scalars['ID']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  tourCalendarId: Scalars['ID']['input'];
  tourId: Scalars['ID']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};

export type CreateEditorialDataInput = {
  editorialDataId: Scalars['ID']['input'];
  editorialJson: Scalars['AWSJSON']['input'];
  seasonId: Scalars['ID']['input'];
};

export type CreateEditorialDataV2Input = {
  editorialDataId: Scalars['ID']['input'];
  editorialJson: Scalars['AWSJSON']['input'];
  tourCalendarId: Scalars['ID']['input'];
};

export type CreateLiveScoreWidgetInput = {
  ctaUrls?: InputMaybe<LiveScoreWidgetCtaUrlInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  liveTournaments?: InputMaybe<Array<InputMaybe<LiveScoreWidgetTournamentInput>>>;
};

export type CreateMatchCardWidgetInput = {
  categoryName?: InputMaybe<Scalars['String']['input']>;
  competitionId?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  firstPosition?: InputMaybe<ResultWidgetPositionInput>;
  matchId: Scalars['ID']['input'];
  resultType?: InputMaybe<Scalars['String']['input']>;
  roundName?: InputMaybe<Scalars['String']['input']>;
  secondPosition?: InputMaybe<ResultWidgetPositionInput>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tournamentId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateMatchInput = {
  competitionId: Scalars['ID']['input'];
  date?: InputMaybe<Scalars['Int']['input']>;
  matchId: Scalars['ID']['input'];
  matchLiveJson?: InputMaybe<Scalars['AWSJSON']['input']>;
  matchScheduleJson?: InputMaybe<Scalars['AWSJSON']['input']>;
  playerA1Id?: InputMaybe<Scalars['ID']['input']>;
  playerA2Id?: InputMaybe<Scalars['ID']['input']>;
  playerAseed?: InputMaybe<Scalars['String']['input']>;
  playerB1Id?: InputMaybe<Scalars['ID']['input']>;
  playerB2Id?: InputMaybe<Scalars['ID']['input']>;
  playerBseed?: InputMaybe<Scalars['String']['input']>;
  roundName?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  teamAId?: InputMaybe<Scalars['String']['input']>;
  teamBId?: InputMaybe<Scalars['String']['input']>;
  tourCalendarId: Scalars['ID']['input'];
  tourId: Scalars['ID']['input'];
  tournamentId: Scalars['ID']['input'];
};

export type CreatePlayerInput = {
  nationalityId?: InputMaybe<Scalars['String']['input']>;
  playerId: Scalars['ID']['input'];
  playerJson?: InputMaybe<Scalars['AWSJSON']['input']>;
  playerName?: InputMaybe<Scalars['String']['input']>;
};

export type CreateRankingInput = {
  playerId: Scalars['ID']['input'];
  rank: Scalars['Int']['input'];
  rankingJson?: InputMaybe<Scalars['AWSJSON']['input']>;
  tourId: Scalars['ID']['input'];
  type: Scalars['String']['input'];
};

export type CreateRankingWidgetInput = {
  rankings?: InputMaybe<Array<InputMaybe<RankingWidgetInfoInput>>>;
  tourId: Scalars['ID']['input'];
  type: Scalars['String']['input'];
};

export type CreateResultsCategoriesWidgetInput = {
  adv?: InputMaybe<ResultsCategoriesWidgetAdvInput>;
  categories?: InputMaybe<Array<InputMaybe<ResultsCategoriesWidgetInfoInput>>>;
  competitionId: Scalars['ID']['input'];
  type: Scalars['String']['input'];
};

export type CreateResultsContainerWidgetInput = {
  competitionId: Scalars['ID']['input'];
  ssi?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type: Scalars['String']['input'];
};

export type CreateResultsWidgetInput = {
  categoryName?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  day: Scalars['ID']['input'];
  matches?: InputMaybe<Array<InputMaybe<ResultsWidgetMatchInput>>>;
  tournamentId: Scalars['ID']['input'];
};

export type CreateTourCalendarInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  tourCalendarId: Scalars['ID']['input'];
  tourId: Scalars['ID']['input'];
  tourName?: InputMaybe<Scalars['String']['input']>;
  tourYear?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTournamentDataWidgetInput = {
  competitionId: Scalars['ID']['input'];
  data?: InputMaybe<Scalars['AWSJSON']['input']>;
  messageType: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type CreateTournamentInput = {
  competitionId: Scalars['ID']['input'];
  tournamentId: Scalars['ID']['input'];
  tournamentJson?: InputMaybe<Scalars['AWSJSON']['input']>;
  tournamentName?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteCalendarWidgetInput = {
  tourId: Scalars['ID']['input'];
  tournamentFilter: Scalars['String']['input'];
};

export type DeleteCompetitionInput = {
  competitionId: Scalars['ID']['input'];
  tourCalendarId: Scalars['ID']['input'];
};

export type DeleteEditorialDataInput = {
  editorialDataId: Scalars['ID']['input'];
  seasonId: Scalars['ID']['input'];
};

export type DeleteEditorialDataV2Input = {
  editorialDataId: Scalars['ID']['input'];
  tourCalendarId: Scalars['ID']['input'];
};

export type DeleteLiveScoreWidgetInput = {
  id: Scalars['ID']['input'];
};

export type DeleteMatchCardWidgetInput = {
  matchId: Scalars['ID']['input'];
};

export type DeleteMatchInput = {
  matchId: Scalars['ID']['input'];
  tournamentId: Scalars['ID']['input'];
};

export type DeletePlayerInput = {
  playerId: Scalars['ID']['input'];
};

export type DeleteRankingInput = {
  rank: Scalars['Int']['input'];
  tourId: Scalars['ID']['input'];
  type: Scalars['String']['input'];
};

export type DeleteRankingWidgetInput = {
  tourId: Scalars['ID']['input'];
  type: Scalars['String']['input'];
};

export type DeleteResultsCategoriesWidgetInput = {
  competitionId: Scalars['ID']['input'];
  type: Scalars['String']['input'];
};

export type DeleteResultsContainerWidgetInput = {
  competitionId: Scalars['ID']['input'];
  type: Scalars['String']['input'];
};

export type DeleteResultsWidgetInput = {
  day: Scalars['ID']['input'];
  tournamentId: Scalars['ID']['input'];
};

export type DeleteTourCalendarInput = {
  tourCalendarId: Scalars['ID']['input'];
  tourId: Scalars['ID']['input'];
};

export type DeleteTournamentDataWidgetInput = {
  competitionId: Scalars['ID']['input'];
  type: Scalars['String']['input'];
};

export type DeleteTournamentInput = {
  competitionId: Scalars['ID']['input'];
  tournamentId: Scalars['ID']['input'];
};

export type EditorialData = {
  __typename?: 'EditorialData';
  createdAt: Scalars['AWSDateTime']['output'];
  editorialDataId: Scalars['ID']['output'];
  editorialJson: Scalars['AWSJSON']['output'];
  seasonId: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type EditorialDataV2 = {
  __typename?: 'EditorialDataV2';
  createdAt: Scalars['AWSDateTime']['output'];
  editorialDataId: Scalars['ID']['output'];
  editorialJson: Scalars['AWSJSON']['output'];
  tourCalendarId: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type LiveScoreWidget = {
  __typename?: 'LiveScoreWidget';
  createdAt: Scalars['AWSDateTime']['output'];
  ctaUrls?: Maybe<LiveScoreWidgetCtaUrl>;
  id: Scalars['ID']['output'];
  liveTournaments?: Maybe<Array<Maybe<LiveScoreWidgetTournament>>>;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type LiveScoreWidgetCtaUrl = {
  __typename?: 'LiveScoreWidgetCtaUrl';
  atpCalendarUrl?: Maybe<Scalars['String']['output']>;
  atpRankingUrl?: Maybe<Scalars['String']['output']>;
  wtaCalendarUrl?: Maybe<Scalars['String']['output']>;
  wtaRankingUrl?: Maybe<Scalars['String']['output']>;
};

export type LiveScoreWidgetCtaUrlInput = {
  atpCalendarUrl?: InputMaybe<Scalars['String']['input']>;
  atpRankingUrl?: InputMaybe<Scalars['String']['input']>;
  wtaCalendarUrl?: InputMaybe<Scalars['String']['input']>;
  wtaRankingUrl?: InputMaybe<Scalars['String']['input']>;
};

export type LiveScoreWidgetMatch = {
  __typename?: 'LiveScoreWidgetMatch';
  firstPosition?: Maybe<LiveScoreWidgetPosition>;
  resultType?: Maybe<Scalars['String']['output']>;
  roundName?: Maybe<Scalars['String']['output']>;
  secondPosition?: Maybe<LiveScoreWidgetPosition>;
  startDate?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type LiveScoreWidgetMatchInput = {
  firstPosition?: InputMaybe<LiveScoreWidgetPositionInput>;
  resultType?: InputMaybe<Scalars['String']['input']>;
  roundName?: InputMaybe<Scalars['String']['input']>;
  secondPosition?: InputMaybe<LiveScoreWidgetPositionInput>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type LiveScoreWidgetPlayer = {
  __typename?: 'LiveScoreWidgetPlayer';
  name?: Maybe<Scalars['String']['output']>;
  nationality?: Maybe<Scalars['String']['output']>;
  seed?: Maybe<Scalars['String']['output']>;
};

export type LiveScoreWidgetPlayerInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  seed?: InputMaybe<Scalars['String']['input']>;
};

export type LiveScoreWidgetPosition = {
  __typename?: 'LiveScoreWidgetPosition';
  gamePoints?: Maybe<Scalars['String']['output']>;
  isServing?: Maybe<Scalars['Boolean']['output']>;
  players?: Maybe<Array<Maybe<LiveScoreWidgetPlayer>>>;
  score?: Maybe<Array<Maybe<LiveScoreWidgetScore>>>;
};

export type LiveScoreWidgetPositionInput = {
  gamePoints?: InputMaybe<Scalars['String']['input']>;
  isServing?: InputMaybe<Scalars['Boolean']['input']>;
  players?: InputMaybe<Array<InputMaybe<LiveScoreWidgetPlayerInput>>>;
  score?: InputMaybe<Array<InputMaybe<LiveScoreWidgetScoreInput>>>;
};

export type LiveScoreWidgetScore = {
  __typename?: 'LiveScoreWidgetScore';
  isWinner?: Maybe<Scalars['Boolean']['output']>;
  set?: Maybe<Scalars['String']['output']>;
  tie?: Maybe<Scalars['String']['output']>;
};

export type LiveScoreWidgetScoreInput = {
  isWinner?: InputMaybe<Scalars['Boolean']['input']>;
  set?: InputMaybe<Scalars['String']['input']>;
  tie?: InputMaybe<Scalars['String']['input']>;
};

export type LiveScoreWidgetTournament = {
  __typename?: 'LiveScoreWidgetTournament';
  categoryName?: Maybe<Scalars['String']['output']>;
  competitionId?: Maybe<Scalars['String']['output']>;
  matches?: Maybe<Array<Maybe<LiveScoreWidgetMatch>>>;
  resultsUrl?: Maybe<Scalars['String']['output']>;
  tourName?: Maybe<Scalars['String']['output']>;
  tourYear?: Maybe<Scalars['String']['output']>;
  tournamentName?: Maybe<Scalars['String']['output']>;
  tournamentType?: Maybe<Scalars['String']['output']>;
};

export type LiveScoreWidgetTournamentInput = {
  categoryName?: InputMaybe<Scalars['String']['input']>;
  competitionId?: InputMaybe<Scalars['String']['input']>;
  matches?: InputMaybe<Array<InputMaybe<LiveScoreWidgetMatchInput>>>;
  resultsUrl?: InputMaybe<Scalars['String']['input']>;
  tourName?: InputMaybe<Scalars['String']['input']>;
  tourYear?: InputMaybe<Scalars['String']['input']>;
  tournamentName?: InputMaybe<Scalars['String']['input']>;
  tournamentType?: InputMaybe<Scalars['String']['input']>;
};

export type Match = {
  __typename?: 'Match';
  competition?: Maybe<Competition>;
  competitionId: Scalars['ID']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  date?: Maybe<Scalars['Int']['output']>;
  matchId: Scalars['ID']['output'];
  matchLiveJson?: Maybe<Scalars['AWSJSON']['output']>;
  matchScheduleJson?: Maybe<Scalars['AWSJSON']['output']>;
  playerA1?: Maybe<Player>;
  playerA1Id?: Maybe<Scalars['ID']['output']>;
  playerA2?: Maybe<Player>;
  playerA2Id?: Maybe<Scalars['ID']['output']>;
  playerAseed?: Maybe<Scalars['String']['output']>;
  playerB1?: Maybe<Player>;
  playerB1Id?: Maybe<Scalars['ID']['output']>;
  playerB2?: Maybe<Player>;
  playerB2Id?: Maybe<Scalars['ID']['output']>;
  playerBseed?: Maybe<Scalars['String']['output']>;
  roundName?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  teamAId?: Maybe<Scalars['String']['output']>;
  teamBId?: Maybe<Scalars['String']['output']>;
  tourCalendar?: Maybe<TourCalendar>;
  tourCalendarId: Scalars['ID']['output'];
  tourId: Scalars['ID']['output'];
  tournament?: Maybe<Tournament>;
  tournamentId: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type MatchCardWidget = {
  __typename?: 'MatchCardWidget';
  categoryName?: Maybe<Scalars['String']['output']>;
  competitionId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  date?: Maybe<Scalars['String']['output']>;
  firstPosition?: Maybe<ResultWidgetPosition>;
  matchId: Scalars['ID']['output'];
  resultType?: Maybe<Scalars['String']['output']>;
  roundName?: Maybe<Scalars['String']['output']>;
  secondPosition?: Maybe<ResultWidgetPosition>;
  startDate?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tournamentId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type ModelBooleanFilterInput = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ModelCalendarWidgetConnection = {
  __typename?: 'ModelCalendarWidgetConnection';
  items: Array<Maybe<CalendarWidget>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelCalendarWidgetFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelCalendarWidgetFilterInput>>>;
  circuitCalendarLink?: InputMaybe<ModelStringFilterInput>;
  filterList?: InputMaybe<ModelStringFilterInput>;
  not?: InputMaybe<ModelCalendarWidgetFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelCalendarWidgetFilterInput>>>;
  tourId?: InputMaybe<ModelIDFilterInput>;
  tournamentFilter?: InputMaybe<ModelStringFilterInput>;
};

export type ModelCompetitionConnection = {
  __typename?: 'ModelCompetitionConnection';
  items: Array<Maybe<Competition>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelCompetitionFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelCompetitionFilterInput>>>;
  competitionId?: InputMaybe<ModelIDFilterInput>;
  competitionJson?: InputMaybe<ModelStringFilterInput>;
  competitionName?: InputMaybe<ModelStringFilterInput>;
  editorialDataId?: InputMaybe<ModelIDFilterInput>;
  endDate?: InputMaybe<ModelStringFilterInput>;
  not?: InputMaybe<ModelCompetitionFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelCompetitionFilterInput>>>;
  startDate?: InputMaybe<ModelStringFilterInput>;
  tourCalendarId?: InputMaybe<ModelIDFilterInput>;
  tourId?: InputMaybe<ModelIDFilterInput>;
  type?: InputMaybe<ModelStringFilterInput>;
};

export type ModelEditorialDataConnection = {
  __typename?: 'ModelEditorialDataConnection';
  items: Array<Maybe<EditorialData>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelEditorialDataFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelEditorialDataFilterInput>>>;
  editorialDataId?: InputMaybe<ModelIDFilterInput>;
  editorialJson?: InputMaybe<ModelStringFilterInput>;
  not?: InputMaybe<ModelEditorialDataFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelEditorialDataFilterInput>>>;
  seasonId?: InputMaybe<ModelIDFilterInput>;
};

export type ModelEditorialDataV2Connection = {
  __typename?: 'ModelEditorialDataV2Connection';
  items: Array<Maybe<EditorialDataV2>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelEditorialDataV2FilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelEditorialDataV2FilterInput>>>;
  editorialDataId?: InputMaybe<ModelIDFilterInput>;
  editorialJson?: InputMaybe<ModelStringFilterInput>;
  not?: InputMaybe<ModelEditorialDataV2FilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelEditorialDataV2FilterInput>>>;
  tourCalendarId?: InputMaybe<ModelIDFilterInput>;
};

export type ModelFloatFilterInput = {
  between?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  eq?: InputMaybe<Scalars['Float']['input']>;
  ge?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  le?: InputMaybe<Scalars['Float']['input']>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
};

export type ModelIDFilterInput = {
  beginsWith?: InputMaybe<Scalars['ID']['input']>;
  between?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  contains?: InputMaybe<Scalars['ID']['input']>;
  eq?: InputMaybe<Scalars['ID']['input']>;
  ge?: InputMaybe<Scalars['ID']['input']>;
  gt?: InputMaybe<Scalars['ID']['input']>;
  le?: InputMaybe<Scalars['ID']['input']>;
  lt?: InputMaybe<Scalars['ID']['input']>;
  ne?: InputMaybe<Scalars['ID']['input']>;
  notContains?: InputMaybe<Scalars['ID']['input']>;
};

export type ModelIDKeyConditionInput = {
  beginsWith?: InputMaybe<Scalars['ID']['input']>;
  between?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  eq?: InputMaybe<Scalars['ID']['input']>;
  ge?: InputMaybe<Scalars['ID']['input']>;
  gt?: InputMaybe<Scalars['ID']['input']>;
  le?: InputMaybe<Scalars['ID']['input']>;
  lt?: InputMaybe<Scalars['ID']['input']>;
};

export type ModelIntFilterInput = {
  between?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  ge?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  le?: InputMaybe<Scalars['Int']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
};

export type ModelIntKeyConditionInput = {
  between?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  ge?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  le?: InputMaybe<Scalars['Int']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
};

export type ModelLiveScoreWidgetConnection = {
  __typename?: 'ModelLiveScoreWidgetConnection';
  items: Array<Maybe<LiveScoreWidget>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelLiveScoreWidgetFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelLiveScoreWidgetFilterInput>>>;
  id?: InputMaybe<ModelIDFilterInput>;
  not?: InputMaybe<ModelLiveScoreWidgetFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelLiveScoreWidgetFilterInput>>>;
};

export type ModelMatchCardWidgetConnection = {
  __typename?: 'ModelMatchCardWidgetConnection';
  items: Array<Maybe<MatchCardWidget>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelMatchCardWidgetFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelMatchCardWidgetFilterInput>>>;
  categoryName?: InputMaybe<ModelStringFilterInput>;
  competitionId?: InputMaybe<ModelStringFilterInput>;
  date?: InputMaybe<ModelStringFilterInput>;
  matchId?: InputMaybe<ModelIDFilterInput>;
  not?: InputMaybe<ModelMatchCardWidgetFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelMatchCardWidgetFilterInput>>>;
  resultType?: InputMaybe<ModelStringFilterInput>;
  roundName?: InputMaybe<ModelStringFilterInput>;
  startDate?: InputMaybe<ModelStringFilterInput>;
  status?: InputMaybe<ModelStringFilterInput>;
  tournamentId?: InputMaybe<ModelStringFilterInput>;
};

export type ModelMatchConnection = {
  __typename?: 'ModelMatchConnection';
  items: Array<Maybe<Match>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelMatchFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelMatchFilterInput>>>;
  competitionId?: InputMaybe<ModelIDFilterInput>;
  date?: InputMaybe<ModelIntFilterInput>;
  matchId?: InputMaybe<ModelIDFilterInput>;
  matchLiveJson?: InputMaybe<ModelStringFilterInput>;
  matchScheduleJson?: InputMaybe<ModelStringFilterInput>;
  not?: InputMaybe<ModelMatchFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelMatchFilterInput>>>;
  playerA1Id?: InputMaybe<ModelIDFilterInput>;
  playerA2Id?: InputMaybe<ModelIDFilterInput>;
  playerAseed?: InputMaybe<ModelStringFilterInput>;
  playerB1Id?: InputMaybe<ModelIDFilterInput>;
  playerB2Id?: InputMaybe<ModelIDFilterInput>;
  playerBseed?: InputMaybe<ModelStringFilterInput>;
  roundName?: InputMaybe<ModelStringFilterInput>;
  status?: InputMaybe<ModelStringFilterInput>;
  teamAId?: InputMaybe<ModelStringFilterInput>;
  teamBId?: InputMaybe<ModelStringFilterInput>;
  tourCalendarId?: InputMaybe<ModelIDFilterInput>;
  tourId?: InputMaybe<ModelIDFilterInput>;
  tournamentId?: InputMaybe<ModelIDFilterInput>;
};

export type ModelPlayerConnection = {
  __typename?: 'ModelPlayerConnection';
  items: Array<Maybe<Player>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelPlayerFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelPlayerFilterInput>>>;
  nationalityId?: InputMaybe<ModelStringFilterInput>;
  not?: InputMaybe<ModelPlayerFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelPlayerFilterInput>>>;
  playerId?: InputMaybe<ModelIDFilterInput>;
  playerJson?: InputMaybe<ModelStringFilterInput>;
  playerName?: InputMaybe<ModelStringFilterInput>;
};

export type ModelRankingConnection = {
  __typename?: 'ModelRankingConnection';
  items: Array<Maybe<Ranking>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelRankingFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelRankingFilterInput>>>;
  not?: InputMaybe<ModelRankingFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelRankingFilterInput>>>;
  playerId?: InputMaybe<ModelIDFilterInput>;
  rank?: InputMaybe<ModelIntFilterInput>;
  rankingJson?: InputMaybe<ModelStringFilterInput>;
  tourId?: InputMaybe<ModelIDFilterInput>;
  type?: InputMaybe<ModelStringFilterInput>;
};

export type ModelRankingPrimaryCompositeKeyConditionInput = {
  beginsWith?: InputMaybe<ModelRankingPrimaryCompositeKeyInput>;
  between?: InputMaybe<Array<InputMaybe<ModelRankingPrimaryCompositeKeyInput>>>;
  eq?: InputMaybe<ModelRankingPrimaryCompositeKeyInput>;
  ge?: InputMaybe<ModelRankingPrimaryCompositeKeyInput>;
  gt?: InputMaybe<ModelRankingPrimaryCompositeKeyInput>;
  le?: InputMaybe<ModelRankingPrimaryCompositeKeyInput>;
  lt?: InputMaybe<ModelRankingPrimaryCompositeKeyInput>;
};

export type ModelRankingPrimaryCompositeKeyInput = {
  rank?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type ModelRankingWidgetConnection = {
  __typename?: 'ModelRankingWidgetConnection';
  items: Array<Maybe<RankingWidget>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelRankingWidgetFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelRankingWidgetFilterInput>>>;
  not?: InputMaybe<ModelRankingWidgetFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelRankingWidgetFilterInput>>>;
  tourId?: InputMaybe<ModelIDFilterInput>;
  type?: InputMaybe<ModelStringFilterInput>;
};

export type ModelResultsCategoriesWidgetConnection = {
  __typename?: 'ModelResultsCategoriesWidgetConnection';
  items: Array<Maybe<ResultsCategoriesWidget>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelResultsCategoriesWidgetFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelResultsCategoriesWidgetFilterInput>>>;
  competitionId?: InputMaybe<ModelIDFilterInput>;
  not?: InputMaybe<ModelResultsCategoriesWidgetFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelResultsCategoriesWidgetFilterInput>>>;
  type?: InputMaybe<ModelStringFilterInput>;
};

export type ModelResultsContainerWidgetConnection = {
  __typename?: 'ModelResultsContainerWidgetConnection';
  items: Array<Maybe<ResultsContainerWidget>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelResultsContainerWidgetFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelResultsContainerWidgetFilterInput>>>;
  competitionId?: InputMaybe<ModelIDFilterInput>;
  not?: InputMaybe<ModelResultsContainerWidgetFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelResultsContainerWidgetFilterInput>>>;
  ssi?: InputMaybe<ModelStringFilterInput>;
  type?: InputMaybe<ModelStringFilterInput>;
};

export type ModelResultsWidgetConnection = {
  __typename?: 'ModelResultsWidgetConnection';
  items: Array<Maybe<ResultsWidget>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelResultsWidgetFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelResultsWidgetFilterInput>>>;
  categoryName?: InputMaybe<ModelStringFilterInput>;
  date?: InputMaybe<ModelStringFilterInput>;
  day?: InputMaybe<ModelIDFilterInput>;
  not?: InputMaybe<ModelResultsWidgetFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelResultsWidgetFilterInput>>>;
  tournamentId?: InputMaybe<ModelIDFilterInput>;
};

export enum ModelSortDirection {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type ModelStringFilterInput = {
  beginsWith?: InputMaybe<Scalars['String']['input']>;
  between?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  ge?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  le?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notContains?: InputMaybe<Scalars['String']['input']>;
};

export type ModelStringKeyConditionInput = {
  beginsWith?: InputMaybe<Scalars['String']['input']>;
  between?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  ge?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  le?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
};

export type ModelTourCalendarConnection = {
  __typename?: 'ModelTourCalendarConnection';
  items: Array<Maybe<TourCalendar>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelTourCalendarFilterInput = {
  active?: InputMaybe<ModelBooleanFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ModelTourCalendarFilterInput>>>;
  endDate?: InputMaybe<ModelStringFilterInput>;
  not?: InputMaybe<ModelTourCalendarFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelTourCalendarFilterInput>>>;
  startDate?: InputMaybe<ModelStringFilterInput>;
  tourCalendarId?: InputMaybe<ModelIDFilterInput>;
  tourId?: InputMaybe<ModelIDFilterInput>;
  tourName?: InputMaybe<ModelStringFilterInput>;
  tourYear?: InputMaybe<ModelStringFilterInput>;
};

export type ModelTournamentConnection = {
  __typename?: 'ModelTournamentConnection';
  items: Array<Maybe<Tournament>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelTournamentDataWidgetConnection = {
  __typename?: 'ModelTournamentDataWidgetConnection';
  items: Array<Maybe<TournamentDataWidget>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelTournamentDataWidgetFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelTournamentDataWidgetFilterInput>>>;
  competitionId?: InputMaybe<ModelIDFilterInput>;
  data?: InputMaybe<ModelStringFilterInput>;
  messageType?: InputMaybe<ModelStringFilterInput>;
  not?: InputMaybe<ModelTournamentDataWidgetFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelTournamentDataWidgetFilterInput>>>;
  type?: InputMaybe<ModelStringFilterInput>;
};

export type ModelTournamentFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelTournamentFilterInput>>>;
  competitionId?: InputMaybe<ModelIDFilterInput>;
  not?: InputMaybe<ModelTournamentFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelTournamentFilterInput>>>;
  tournamentId?: InputMaybe<ModelIDFilterInput>;
  tournamentJson?: InputMaybe<ModelStringFilterInput>;
  tournamentName?: InputMaybe<ModelStringFilterInput>;
};

export type Mutation = {
  __typename?: 'Mutation';
  createCalendarWidget?: Maybe<CalendarWidget>;
  createCompetition?: Maybe<Competition>;
  createEditorialData?: Maybe<EditorialData>;
  createEditorialDataV2?: Maybe<EditorialDataV2>;
  createLiveScoreWidget?: Maybe<LiveScoreWidget>;
  createMatch?: Maybe<Match>;
  createMatchCardWidget?: Maybe<MatchCardWidget>;
  createPlayer?: Maybe<Player>;
  createRanking?: Maybe<Ranking>;
  createRankingWidget?: Maybe<RankingWidget>;
  createResultsCategoriesWidget?: Maybe<ResultsCategoriesWidget>;
  createResultsContainerWidget?: Maybe<ResultsContainerWidget>;
  createResultsWidget?: Maybe<ResultsWidget>;
  createTourCalendar?: Maybe<TourCalendar>;
  createTournament?: Maybe<Tournament>;
  createTournamentDataWidget?: Maybe<TournamentDataWidget>;
  deleteCalendarWidget?: Maybe<CalendarWidget>;
  deleteCompetition?: Maybe<Competition>;
  deleteEditorialData?: Maybe<EditorialData>;
  deleteEditorialDataV2?: Maybe<EditorialDataV2>;
  deleteLiveScoreWidget?: Maybe<LiveScoreWidget>;
  deleteMatch?: Maybe<Match>;
  deleteMatchCardWidget?: Maybe<MatchCardWidget>;
  deletePlayer?: Maybe<Player>;
  deleteRanking?: Maybe<Ranking>;
  deleteRankingWidget?: Maybe<RankingWidget>;
  deleteResultsCategoriesWidget?: Maybe<ResultsCategoriesWidget>;
  deleteResultsContainerWidget?: Maybe<ResultsContainerWidget>;
  deleteResultsWidget?: Maybe<ResultsWidget>;
  deleteTourCalendar?: Maybe<TourCalendar>;
  deleteTournament?: Maybe<Tournament>;
  deleteTournamentDataWidget?: Maybe<TournamentDataWidget>;
  updateCalendarWidget?: Maybe<CalendarWidget>;
  updateCompetition?: Maybe<Competition>;
  updateEditorialData?: Maybe<EditorialData>;
  updateEditorialDataV2?: Maybe<EditorialDataV2>;
  updateLiveScoreWidget?: Maybe<LiveScoreWidget>;
  updateMatch?: Maybe<Match>;
  updateMatchCardWidget?: Maybe<MatchCardWidget>;
  updatePlayer?: Maybe<Player>;
  updateRanking?: Maybe<Ranking>;
  updateRankingWidget?: Maybe<RankingWidget>;
  updateResultsCategoriesWidget?: Maybe<ResultsCategoriesWidget>;
  updateResultsContainerWidget?: Maybe<ResultsContainerWidget>;
  updateResultsWidget?: Maybe<ResultsWidget>;
  updateTourCalendar?: Maybe<TourCalendar>;
  updateTournament?: Maybe<Tournament>;
  updateTournamentDataWidget?: Maybe<TournamentDataWidget>;
};


export type MutationcreateCalendarWidgetArgs = {
  input: CreateCalendarWidgetInput;
};


export type MutationcreateCompetitionArgs = {
  input: CreateCompetitionInput;
};


export type MutationcreateEditorialDataArgs = {
  input: CreateEditorialDataInput;
};


export type MutationcreateEditorialDataV2Args = {
  input: CreateEditorialDataV2Input;
};


export type MutationcreateLiveScoreWidgetArgs = {
  input: CreateLiveScoreWidgetInput;
};


export type MutationcreateMatchArgs = {
  input: CreateMatchInput;
};


export type MutationcreateMatchCardWidgetArgs = {
  input: CreateMatchCardWidgetInput;
};


export type MutationcreatePlayerArgs = {
  input: CreatePlayerInput;
};


export type MutationcreateRankingArgs = {
  input: CreateRankingInput;
};


export type MutationcreateRankingWidgetArgs = {
  input: CreateRankingWidgetInput;
};


export type MutationcreateResultsCategoriesWidgetArgs = {
  input: CreateResultsCategoriesWidgetInput;
};


export type MutationcreateResultsContainerWidgetArgs = {
  input: CreateResultsContainerWidgetInput;
};


export type MutationcreateResultsWidgetArgs = {
  input: CreateResultsWidgetInput;
};


export type MutationcreateTourCalendarArgs = {
  input: CreateTourCalendarInput;
};


export type MutationcreateTournamentArgs = {
  input: CreateTournamentInput;
};


export type MutationcreateTournamentDataWidgetArgs = {
  input: CreateTournamentDataWidgetInput;
};


export type MutationdeleteCalendarWidgetArgs = {
  input: DeleteCalendarWidgetInput;
};


export type MutationdeleteCompetitionArgs = {
  input: DeleteCompetitionInput;
};


export type MutationdeleteEditorialDataArgs = {
  input: DeleteEditorialDataInput;
};


export type MutationdeleteEditorialDataV2Args = {
  input: DeleteEditorialDataV2Input;
};


export type MutationdeleteLiveScoreWidgetArgs = {
  input: DeleteLiveScoreWidgetInput;
};


export type MutationdeleteMatchArgs = {
  input: DeleteMatchInput;
};


export type MutationdeleteMatchCardWidgetArgs = {
  input: DeleteMatchCardWidgetInput;
};


export type MutationdeletePlayerArgs = {
  input: DeletePlayerInput;
};


export type MutationdeleteRankingArgs = {
  input: DeleteRankingInput;
};


export type MutationdeleteRankingWidgetArgs = {
  input: DeleteRankingWidgetInput;
};


export type MutationdeleteResultsCategoriesWidgetArgs = {
  input: DeleteResultsCategoriesWidgetInput;
};


export type MutationdeleteResultsContainerWidgetArgs = {
  input: DeleteResultsContainerWidgetInput;
};


export type MutationdeleteResultsWidgetArgs = {
  input: DeleteResultsWidgetInput;
};


export type MutationdeleteTourCalendarArgs = {
  input: DeleteTourCalendarInput;
};


export type MutationdeleteTournamentArgs = {
  input: DeleteTournamentInput;
};


export type MutationdeleteTournamentDataWidgetArgs = {
  input: DeleteTournamentDataWidgetInput;
};


export type MutationupdateCalendarWidgetArgs = {
  input: UpdateCalendarWidgetInput;
};


export type MutationupdateCompetitionArgs = {
  input: UpdateCompetitionInput;
};


export type MutationupdateEditorialDataArgs = {
  input: UpdateEditorialDataInput;
};


export type MutationupdateEditorialDataV2Args = {
  input: UpdateEditorialDataV2Input;
};


export type MutationupdateLiveScoreWidgetArgs = {
  input: UpdateLiveScoreWidgetInput;
};


export type MutationupdateMatchArgs = {
  input: UpdateMatchInput;
};


export type MutationupdateMatchCardWidgetArgs = {
  input: UpdateMatchCardWidgetInput;
};


export type MutationupdatePlayerArgs = {
  input: UpdatePlayerInput;
};


export type MutationupdateRankingArgs = {
  input: UpdateRankingInput;
};


export type MutationupdateRankingWidgetArgs = {
  input: UpdateRankingWidgetInput;
};


export type MutationupdateResultsCategoriesWidgetArgs = {
  input: UpdateResultsCategoriesWidgetInput;
};


export type MutationupdateResultsContainerWidgetArgs = {
  input: UpdateResultsContainerWidgetInput;
};


export type MutationupdateResultsWidgetArgs = {
  input: UpdateResultsWidgetInput;
};


export type MutationupdateTourCalendarArgs = {
  input: UpdateTourCalendarInput;
};


export type MutationupdateTournamentArgs = {
  input: UpdateTournamentInput;
};


export type MutationupdateTournamentDataWidgetArgs = {
  input: UpdateTournamentDataWidgetInput;
};

export type Player = {
  __typename?: 'Player';
  createdAt: Scalars['AWSDateTime']['output'];
  nationalityId?: Maybe<Scalars['String']['output']>;
  playerId: Scalars['ID']['output'];
  playerJson?: Maybe<Scalars['AWSJSON']['output']>;
  playerName?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type Query = {
  __typename?: 'Query';
  getCalendarWidget?: Maybe<CalendarWidget>;
  getCompetition?: Maybe<Competition>;
  getCompetitionByTourCalendarId?: Maybe<ModelCompetitionConnection>;
  getEditorialData?: Maybe<EditorialData>;
  getEditorialDataById?: Maybe<ModelEditorialDataConnection>;
  getEditorialDataV2?: Maybe<EditorialDataV2>;
  getEditorialDataV2ById?: Maybe<ModelEditorialDataV2Connection>;
  getLiveScoreWidget?: Maybe<LiveScoreWidget>;
  getMatch?: Maybe<Match>;
  getMatchByDate?: Maybe<ModelMatchConnection>;
  getMatchById?: Maybe<ModelMatchConnection>;
  getMatchByTourCalendarAndStatus?: Maybe<ModelMatchConnection>;
  getMatchByTournamentId?: Maybe<ModelMatchConnection>;
  getMatchCardWidget?: Maybe<MatchCardWidget>;
  getPlayer?: Maybe<Player>;
  getRanking?: Maybe<Ranking>;
  getRankingWidget?: Maybe<RankingWidget>;
  getResultsCategoriesWidget?: Maybe<ResultsCategoriesWidget>;
  getResultsContainerWidget?: Maybe<ResultsContainerWidget>;
  getResultsWidget?: Maybe<ResultsWidget>;
  getTourCalendar?: Maybe<TourCalendar>;
  getTournament?: Maybe<Tournament>;
  getTournamentByCompetitionId?: Maybe<ModelTournamentConnection>;
  getTournamentDataWidget?: Maybe<TournamentDataWidget>;
  listCalendarWidgets?: Maybe<ModelCalendarWidgetConnection>;
  listCompetitions?: Maybe<ModelCompetitionConnection>;
  listEditorialDataV2s?: Maybe<ModelEditorialDataV2Connection>;
  listEditorialDatas?: Maybe<ModelEditorialDataConnection>;
  listLiveScoreWidgets?: Maybe<ModelLiveScoreWidgetConnection>;
  listMatchCardWidgets?: Maybe<ModelMatchCardWidgetConnection>;
  listMatchs?: Maybe<ModelMatchConnection>;
  listPlayers?: Maybe<ModelPlayerConnection>;
  listRankingWidgets?: Maybe<ModelRankingWidgetConnection>;
  listRankings?: Maybe<ModelRankingConnection>;
  listResultsCategoriesWidgets?: Maybe<ModelResultsCategoriesWidgetConnection>;
  listResultsContainerWidgets?: Maybe<ModelResultsContainerWidgetConnection>;
  listResultsWidgets?: Maybe<ModelResultsWidgetConnection>;
  listTourCalendars?: Maybe<ModelTourCalendarConnection>;
  listTournamentDataWidgets?: Maybe<ModelTournamentDataWidgetConnection>;
  listTournaments?: Maybe<ModelTournamentConnection>;
};


export type QuerygetCalendarWidgetArgs = {
  tourId: Scalars['ID']['input'];
  tournamentFilter: Scalars['String']['input'];
};


export type QuerygetCompetitionArgs = {
  competitionId: Scalars['ID']['input'];
  tourCalendarId: Scalars['ID']['input'];
};


export type QuerygetCompetitionByTourCalendarIdArgs = {
  competitionId?: InputMaybe<ModelIDKeyConditionInput>;
  filter?: InputMaybe<ModelCompetitionFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  tourCalendarId?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerygetEditorialDataArgs = {
  editorialDataId: Scalars['ID']['input'];
  seasonId: Scalars['ID']['input'];
};


export type QuerygetEditorialDataByIdArgs = {
  editorialDataId?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<ModelEditorialDataFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerygetEditorialDataV2Args = {
  editorialDataId: Scalars['ID']['input'];
  tourCalendarId: Scalars['ID']['input'];
};


export type QuerygetEditorialDataV2ByIdArgs = {
  editorialDataId?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<ModelEditorialDataV2FilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerygetLiveScoreWidgetArgs = {
  id: Scalars['ID']['input'];
};


export type QuerygetMatchArgs = {
  matchId: Scalars['ID']['input'];
  tournamentId: Scalars['ID']['input'];
};


export type QuerygetMatchByDateArgs = {
  date?: InputMaybe<ModelIntKeyConditionInput>;
  filter?: InputMaybe<ModelMatchFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  tournamentId?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerygetMatchByIdArgs = {
  filter?: InputMaybe<ModelMatchFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  matchId?: InputMaybe<Scalars['ID']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerygetMatchByTourCalendarAndStatusArgs = {
  filter?: InputMaybe<ModelMatchFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  status?: InputMaybe<ModelStringKeyConditionInput>;
  tourCalendarId?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerygetMatchByTournamentIdArgs = {
  filter?: InputMaybe<ModelMatchFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  matchId?: InputMaybe<ModelIDKeyConditionInput>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  tournamentId?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerygetMatchCardWidgetArgs = {
  matchId: Scalars['ID']['input'];
};


export type QuerygetPlayerArgs = {
  playerId: Scalars['ID']['input'];
};


export type QuerygetRankingArgs = {
  rank: Scalars['Int']['input'];
  tourId: Scalars['ID']['input'];
  type: Scalars['String']['input'];
};


export type QuerygetRankingWidgetArgs = {
  tourId: Scalars['ID']['input'];
  type: Scalars['String']['input'];
};


export type QuerygetResultsCategoriesWidgetArgs = {
  competitionId: Scalars['ID']['input'];
  type: Scalars['String']['input'];
};


export type QuerygetResultsContainerWidgetArgs = {
  competitionId: Scalars['ID']['input'];
  type: Scalars['String']['input'];
};


export type QuerygetResultsWidgetArgs = {
  day: Scalars['ID']['input'];
  tournamentId: Scalars['ID']['input'];
};


export type QuerygetTourCalendarArgs = {
  tourCalendarId: Scalars['ID']['input'];
  tourId: Scalars['ID']['input'];
};


export type QuerygetTournamentArgs = {
  competitionId: Scalars['ID']['input'];
  tournamentId: Scalars['ID']['input'];
};


export type QuerygetTournamentByCompetitionIdArgs = {
  competitionId?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<ModelTournamentFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerygetTournamentDataWidgetArgs = {
  competitionId: Scalars['ID']['input'];
  type: Scalars['String']['input'];
};


export type QuerylistCalendarWidgetsArgs = {
  filter?: InputMaybe<ModelCalendarWidgetFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  tourId?: InputMaybe<Scalars['ID']['input']>;
  tournamentFilter?: InputMaybe<ModelStringKeyConditionInput>;
};


export type QuerylistCompetitionsArgs = {
  competitionId?: InputMaybe<ModelIDKeyConditionInput>;
  filter?: InputMaybe<ModelCompetitionFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  tourCalendarId?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerylistEditorialDataV2sArgs = {
  editorialDataId?: InputMaybe<ModelIDKeyConditionInput>;
  filter?: InputMaybe<ModelEditorialDataV2FilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  tourCalendarId?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerylistEditorialDatasArgs = {
  editorialDataId?: InputMaybe<ModelIDKeyConditionInput>;
  filter?: InputMaybe<ModelEditorialDataFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  seasonId?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistLiveScoreWidgetsArgs = {
  filter?: InputMaybe<ModelLiveScoreWidgetFilterInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistMatchCardWidgetsArgs = {
  filter?: InputMaybe<ModelMatchCardWidgetFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  matchId?: InputMaybe<Scalars['ID']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistMatchsArgs = {
  filter?: InputMaybe<ModelMatchFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  matchId?: InputMaybe<ModelIDKeyConditionInput>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  tournamentId?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerylistPlayersArgs = {
  filter?: InputMaybe<ModelPlayerFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  playerId?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistRankingWidgetsArgs = {
  filter?: InputMaybe<ModelRankingWidgetFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  tourId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<ModelStringKeyConditionInput>;
};


export type QuerylistRankingsArgs = {
  filter?: InputMaybe<ModelRankingFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  tourId?: InputMaybe<Scalars['ID']['input']>;
  typeRank?: InputMaybe<ModelRankingPrimaryCompositeKeyConditionInput>;
};


export type QuerylistResultsCategoriesWidgetsArgs = {
  competitionId?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<ModelResultsCategoriesWidgetFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  type?: InputMaybe<ModelStringKeyConditionInput>;
};


export type QuerylistResultsContainerWidgetsArgs = {
  competitionId?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<ModelResultsContainerWidgetFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  type?: InputMaybe<ModelStringKeyConditionInput>;
};


export type QuerylistResultsWidgetsArgs = {
  day?: InputMaybe<ModelIDKeyConditionInput>;
  filter?: InputMaybe<ModelResultsWidgetFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  tournamentId?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerylistTourCalendarsArgs = {
  filter?: InputMaybe<ModelTourCalendarFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  tourCalendarId?: InputMaybe<ModelIDKeyConditionInput>;
  tourId?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerylistTournamentDataWidgetsArgs = {
  competitionId?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<ModelTournamentDataWidgetFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  type?: InputMaybe<ModelStringKeyConditionInput>;
};


export type QuerylistTournamentsArgs = {
  competitionId?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<ModelTournamentFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  tournamentId?: InputMaybe<ModelIDKeyConditionInput>;
};

export type Ranking = {
  __typename?: 'Ranking';
  createdAt: Scalars['AWSDateTime']['output'];
  player?: Maybe<Player>;
  playerId: Scalars['ID']['output'];
  rank: Scalars['Int']['output'];
  rankingJson?: Maybe<Scalars['AWSJSON']['output']>;
  tourId: Scalars['ID']['output'];
  type: Scalars['String']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type RankingWidget = {
  __typename?: 'RankingWidget';
  createdAt: Scalars['AWSDateTime']['output'];
  rankings?: Maybe<Array<Maybe<RankingWidgetInfo>>>;
  tourId: Scalars['ID']['output'];
  type: Scalars['String']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type RankingWidgetInfo = {
  __typename?: 'RankingWidgetInfo';
  nationality?: Maybe<Scalars['String']['output']>;
  playerName?: Maybe<Scalars['String']['output']>;
  points?: Maybe<Scalars['String']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  trend?: Maybe<Scalars['String']['output']>;
};

export type RankingWidgetInfoInput = {
  nationality?: InputMaybe<Scalars['String']['input']>;
  playerName?: InputMaybe<Scalars['String']['input']>;
  points?: InputMaybe<Scalars['String']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  trend?: InputMaybe<Scalars['String']['input']>;
};

export type ResultWidgetPlayer = {
  __typename?: 'ResultWidgetPlayer';
  name?: Maybe<Scalars['String']['output']>;
  nationality?: Maybe<Scalars['String']['output']>;
  seed?: Maybe<Scalars['String']['output']>;
};

export type ResultWidgetPlayerInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  seed?: InputMaybe<Scalars['String']['input']>;
};

export type ResultWidgetPosition = {
  __typename?: 'ResultWidgetPosition';
  gamePoints?: Maybe<Scalars['String']['output']>;
  isServing?: Maybe<Scalars['Boolean']['output']>;
  isWinner?: Maybe<Scalars['Boolean']['output']>;
  players?: Maybe<Array<Maybe<ResultWidgetPlayer>>>;
  score?: Maybe<Array<Maybe<ResultWidgetScore>>>;
};

export type ResultWidgetPositionInput = {
  gamePoints?: InputMaybe<Scalars['String']['input']>;
  isServing?: InputMaybe<Scalars['Boolean']['input']>;
  isWinner?: InputMaybe<Scalars['Boolean']['input']>;
  players?: InputMaybe<Array<InputMaybe<ResultWidgetPlayerInput>>>;
  score?: InputMaybe<Array<InputMaybe<ResultWidgetScoreInput>>>;
};

export type ResultWidgetScore = {
  __typename?: 'ResultWidgetScore';
  isWinner?: Maybe<Scalars['Boolean']['output']>;
  set?: Maybe<Scalars['String']['output']>;
  tie?: Maybe<Scalars['String']['output']>;
};

export type ResultWidgetScoreInput = {
  isWinner?: InputMaybe<Scalars['Boolean']['input']>;
  set?: InputMaybe<Scalars['String']['input']>;
  tie?: InputMaybe<Scalars['String']['input']>;
};

export type ResultsCategoriesWidget = {
  __typename?: 'ResultsCategoriesWidget';
  adv?: Maybe<ResultsCategoriesWidgetAdv>;
  categories?: Maybe<Array<Maybe<ResultsCategoriesWidgetInfo>>>;
  competitionId: Scalars['ID']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  type: Scalars['String']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type ResultsCategoriesWidgetAdv = {
  __typename?: 'ResultsCategoriesWidgetAdv';
  image?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
};

export type ResultsCategoriesWidgetAdvInput = {
  image?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
};

export type ResultsCategoriesWidgetInfo = {
  __typename?: 'ResultsCategoriesWidgetInfo';
  dates?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ResultsCategoriesWidgetInfoInput = {
  dates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ResultsContainerWidget = {
  __typename?: 'ResultsContainerWidget';
  competitionId: Scalars['ID']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  ssi?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  type: Scalars['String']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type ResultsWidget = {
  __typename?: 'ResultsWidget';
  categoryName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  date?: Maybe<Scalars['String']['output']>;
  day: Scalars['ID']['output'];
  matches?: Maybe<Array<Maybe<ResultsWidgetMatch>>>;
  tournamentId: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type ResultsWidgetMatch = {
  __typename?: 'ResultsWidgetMatch';
  firstPosition?: Maybe<ResultWidgetPosition>;
  resultType?: Maybe<Scalars['String']['output']>;
  roundName?: Maybe<Scalars['String']['output']>;
  secondPosition?: Maybe<ResultWidgetPosition>;
  startDate?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type ResultsWidgetMatchInput = {
  firstPosition?: InputMaybe<ResultWidgetPositionInput>;
  resultType?: InputMaybe<Scalars['String']['input']>;
  roundName?: InputMaybe<Scalars['String']['input']>;
  secondPosition?: InputMaybe<ResultWidgetPositionInput>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  onCreateCalendarWidget?: Maybe<CalendarWidget>;
  onCreateCompetition?: Maybe<Competition>;
  onCreateEditorialData?: Maybe<EditorialData>;
  onCreateEditorialDataV2?: Maybe<EditorialDataV2>;
  onCreateLiveScoreWidget?: Maybe<LiveScoreWidget>;
  onCreateMatch?: Maybe<Match>;
  onCreateMatchCardWidget?: Maybe<MatchCardWidget>;
  onCreatePlayer?: Maybe<Player>;
  onCreateRanking?: Maybe<Ranking>;
  onCreateRankingWidget?: Maybe<RankingWidget>;
  onCreateResultsCategoriesWidget?: Maybe<ResultsCategoriesWidget>;
  onCreateResultsContainerWidget?: Maybe<ResultsContainerWidget>;
  onCreateResultsWidget?: Maybe<ResultsWidget>;
  onCreateTourCalendar?: Maybe<TourCalendar>;
  onCreateTournament?: Maybe<Tournament>;
  onCreateTournamentDataWidget?: Maybe<TournamentDataWidget>;
  onDeleteCalendarWidget?: Maybe<CalendarWidget>;
  onDeleteCompetition?: Maybe<Competition>;
  onDeleteEditorialData?: Maybe<EditorialData>;
  onDeleteEditorialDataV2?: Maybe<EditorialDataV2>;
  onDeleteLiveScoreWidget?: Maybe<LiveScoreWidget>;
  onDeleteMatch?: Maybe<Match>;
  onDeleteMatchCardWidget?: Maybe<MatchCardWidget>;
  onDeletePlayer?: Maybe<Player>;
  onDeleteRanking?: Maybe<Ranking>;
  onDeleteRankingWidget?: Maybe<RankingWidget>;
  onDeleteResultsCategoriesWidget?: Maybe<ResultsCategoriesWidget>;
  onDeleteResultsContainerWidget?: Maybe<ResultsContainerWidget>;
  onDeleteResultsWidget?: Maybe<ResultsWidget>;
  onDeleteTourCalendar?: Maybe<TourCalendar>;
  onDeleteTournament?: Maybe<Tournament>;
  onDeleteTournamentDataWidget?: Maybe<TournamentDataWidget>;
  onUpdateCalendarWidget?: Maybe<CalendarWidget>;
  onUpdateCompetition?: Maybe<Competition>;
  onUpdateEditorialData?: Maybe<EditorialData>;
  onUpdateEditorialDataV2?: Maybe<EditorialDataV2>;
  onUpdateLiveScoreById?: Maybe<LiveScoreWidget>;
  onUpdateLiveScoreWidget?: Maybe<LiveScoreWidget>;
  onUpdateMatch?: Maybe<Match>;
  onUpdateMatchCardById?: Maybe<MatchCardWidget>;
  onUpdateMatchCardWidget?: Maybe<MatchCardWidget>;
  onUpdatePlayer?: Maybe<Player>;
  onUpdateRanking?: Maybe<Ranking>;
  onUpdateRankingWidget?: Maybe<RankingWidget>;
  onUpdateRankingWidgetByTourId?: Maybe<RankingWidget>;
  onUpdateResultsCategoriesWidget?: Maybe<ResultsCategoriesWidget>;
  onUpdateResultsContainerWidget?: Maybe<ResultsContainerWidget>;
  onUpdateResultsWidget?: Maybe<ResultsWidget>;
  onUpdateResultsWidgetByDay?: Maybe<ResultsWidget>;
  onUpdateTourCalendar?: Maybe<TourCalendar>;
  onUpdateTournament?: Maybe<Tournament>;
  onUpdateTournamentDataWidget?: Maybe<TournamentDataWidget>;
};


export type SubscriptiononUpdateLiveScoreByIdArgs = {
  id: Scalars['ID']['input'];
};


export type SubscriptiononUpdateMatchCardByIdArgs = {
  matchId: Scalars['ID']['input'];
};


export type SubscriptiononUpdateRankingWidgetByTourIdArgs = {
  tourId: Scalars['ID']['input'];
  type: Scalars['String']['input'];
};


export type SubscriptiononUpdateResultsWidgetByDayArgs = {
  day: Scalars['ID']['input'];
  tournamentId: Scalars['ID']['input'];
};

export type TourCalendar = {
  __typename?: 'TourCalendar';
  active?: Maybe<Scalars['Boolean']['output']>;
  competitions?: Maybe<ModelCompetitionConnection>;
  createdAt: Scalars['AWSDateTime']['output'];
  endDate?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  tourCalendarId: Scalars['ID']['output'];
  tourId: Scalars['ID']['output'];
  tourName?: Maybe<Scalars['String']['output']>;
  tourYear?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
};


export type TourCalendarcompetitionsArgs = {
  competitionId?: InputMaybe<ModelIDKeyConditionInput>;
  filter?: InputMaybe<ModelCompetitionFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};

export type Tournament = {
  __typename?: 'Tournament';
  competition?: Maybe<Competition>;
  competitionId: Scalars['ID']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  tournamentId: Scalars['ID']['output'];
  tournamentJson?: Maybe<Scalars['AWSJSON']['output']>;
  tournamentName?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type TournamentDataWidget = {
  __typename?: 'TournamentDataWidget';
  competitionId: Scalars['ID']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  data?: Maybe<Scalars['AWSJSON']['output']>;
  messageType: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type UpdateCalendarWidgetInput = {
  circuitCalendarLink?: InputMaybe<Scalars['String']['input']>;
  filterList?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tourId: Scalars['ID']['input'];
  tournamentFilter: Scalars['String']['input'];
  tournaments?: InputMaybe<Array<InputMaybe<CalendarWidgetInfoInput>>>;
};

export type UpdateCompetitionInput = {
  competitionId: Scalars['ID']['input'];
  competitionJson?: InputMaybe<Scalars['AWSJSON']['input']>;
  competitionName?: InputMaybe<Scalars['String']['input']>;
  editorialDataId?: InputMaybe<Scalars['ID']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  tourCalendarId: Scalars['ID']['input'];
  tourId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateEditorialDataInput = {
  editorialDataId: Scalars['ID']['input'];
  editorialJson?: InputMaybe<Scalars['AWSJSON']['input']>;
  seasonId: Scalars['ID']['input'];
};

export type UpdateEditorialDataV2Input = {
  editorialDataId: Scalars['ID']['input'];
  editorialJson?: InputMaybe<Scalars['AWSJSON']['input']>;
  tourCalendarId: Scalars['ID']['input'];
};

export type UpdateLiveScoreWidgetInput = {
  ctaUrls?: InputMaybe<LiveScoreWidgetCtaUrlInput>;
  id: Scalars['ID']['input'];
  liveTournaments?: InputMaybe<Array<InputMaybe<LiveScoreWidgetTournamentInput>>>;
};

export type UpdateMatchCardWidgetInput = {
  categoryName?: InputMaybe<Scalars['String']['input']>;
  competitionId?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  firstPosition?: InputMaybe<ResultWidgetPositionInput>;
  matchId: Scalars['ID']['input'];
  resultType?: InputMaybe<Scalars['String']['input']>;
  roundName?: InputMaybe<Scalars['String']['input']>;
  secondPosition?: InputMaybe<ResultWidgetPositionInput>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tournamentId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMatchInput = {
  competitionId?: InputMaybe<Scalars['ID']['input']>;
  date?: InputMaybe<Scalars['Int']['input']>;
  matchId: Scalars['ID']['input'];
  matchLiveJson?: InputMaybe<Scalars['AWSJSON']['input']>;
  matchScheduleJson?: InputMaybe<Scalars['AWSJSON']['input']>;
  playerA1Id?: InputMaybe<Scalars['ID']['input']>;
  playerA2Id?: InputMaybe<Scalars['ID']['input']>;
  playerAseed?: InputMaybe<Scalars['String']['input']>;
  playerB1Id?: InputMaybe<Scalars['ID']['input']>;
  playerB2Id?: InputMaybe<Scalars['ID']['input']>;
  playerBseed?: InputMaybe<Scalars['String']['input']>;
  roundName?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  teamAId?: InputMaybe<Scalars['String']['input']>;
  teamBId?: InputMaybe<Scalars['String']['input']>;
  tourCalendarId?: InputMaybe<Scalars['ID']['input']>;
  tourId?: InputMaybe<Scalars['ID']['input']>;
  tournamentId: Scalars['ID']['input'];
};

export type UpdatePlayerInput = {
  nationalityId?: InputMaybe<Scalars['String']['input']>;
  playerId: Scalars['ID']['input'];
  playerJson?: InputMaybe<Scalars['AWSJSON']['input']>;
  playerName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateRankingInput = {
  playerId?: InputMaybe<Scalars['ID']['input']>;
  rank: Scalars['Int']['input'];
  rankingJson?: InputMaybe<Scalars['AWSJSON']['input']>;
  tourId: Scalars['ID']['input'];
  type: Scalars['String']['input'];
};

export type UpdateRankingWidgetInput = {
  rankings?: InputMaybe<Array<InputMaybe<RankingWidgetInfoInput>>>;
  tourId: Scalars['ID']['input'];
  type: Scalars['String']['input'];
};

export type UpdateResultsCategoriesWidgetInput = {
  adv?: InputMaybe<ResultsCategoriesWidgetAdvInput>;
  categories?: InputMaybe<Array<InputMaybe<ResultsCategoriesWidgetInfoInput>>>;
  competitionId: Scalars['ID']['input'];
  type: Scalars['String']['input'];
};

export type UpdateResultsContainerWidgetInput = {
  competitionId: Scalars['ID']['input'];
  ssi?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type: Scalars['String']['input'];
};

export type UpdateResultsWidgetInput = {
  categoryName?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  day: Scalars['ID']['input'];
  matches?: InputMaybe<Array<InputMaybe<ResultsWidgetMatchInput>>>;
  tournamentId: Scalars['ID']['input'];
};

export type UpdateTourCalendarInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  tourCalendarId: Scalars['ID']['input'];
  tourId: Scalars['ID']['input'];
  tourName?: InputMaybe<Scalars['String']['input']>;
  tourYear?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTournamentDataWidgetInput = {
  competitionId: Scalars['ID']['input'];
  data?: InputMaybe<Scalars['AWSJSON']['input']>;
  messageType?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

export type UpdateTournamentInput = {
  competitionId: Scalars['ID']['input'];
  tournamentId: Scalars['ID']['input'];
  tournamentJson?: InputMaybe<Scalars['AWSJSON']['input']>;
  tournamentName?: InputMaybe<Scalars['String']['input']>;
};

export type getCalendarWidgetQueryVariables = Exact<{
  tourId: Scalars['ID']['input'];
  tournamentFilter: Scalars['String']['input'];
}>;


export type getCalendarWidgetQuery = { __typename?: 'Query', getCalendarWidget?: { __typename?: 'CalendarWidget', tourId: string, tournamentFilter: string, filterList?: Array<string | null> | null, circuitCalendarLink?: string | null, tournaments?: Array<{ __typename?: 'CalendarWidgetInfo', endDate?: string | null, startDate?: string | null, status?: string | null, surface?: string | null, tournamentName?: string | null, tournamentPlace?: string | null, tournamentType?: string | null, href?: string | null } | null> | null } | null };

export type getLiveScoreWidgetQueryVariables = Exact<{ [key: string]: never; }>;


export type getLiveScoreWidgetQuery = { __typename?: 'Query', getLiveScoreWidget?: { __typename?: 'LiveScoreWidget', id: string, liveTournaments?: Array<{ __typename?: 'LiveScoreWidgetTournament', competitionId?: string | null, tourYear?: string | null, categoryName?: string | null, tourName?: string | null, tournamentName?: string | null, tournamentType?: string | null, resultsUrl?: string | null, matches?: Array<{ __typename?: 'LiveScoreWidgetMatch', status?: string | null, startDate?: string | null, roundName?: string | null, resultType?: string | null, firstPosition?: { __typename?: 'LiveScoreWidgetPosition', isServing?: boolean | null, gamePoints?: string | null, players?: Array<{ __typename?: 'LiveScoreWidgetPlayer', name?: string | null, nationality?: string | null, seed?: string | null } | null> | null, score?: Array<{ __typename?: 'LiveScoreWidgetScore', isWinner?: boolean | null, set?: string | null, tie?: string | null } | null> | null } | null, secondPosition?: { __typename?: 'LiveScoreWidgetPosition', isServing?: boolean | null, gamePoints?: string | null, players?: Array<{ __typename?: 'LiveScoreWidgetPlayer', name?: string | null, nationality?: string | null, seed?: string | null } | null> | null, score?: Array<{ __typename?: 'LiveScoreWidgetScore', isWinner?: boolean | null, set?: string | null, tie?: string | null } | null> | null } | null } | null> | null } | null> | null, ctaUrls?: { __typename?: 'LiveScoreWidgetCtaUrl', atpCalendarUrl?: string | null, wtaCalendarUrl?: string | null, atpRankingUrl?: string | null, wtaRankingUrl?: string | null } | null } | null };

export type getMatchCardWidgetQueryVariables = Exact<{
  matchId: Scalars['ID']['input'];
}>;


export type getMatchCardWidgetQuery = { __typename?: 'Query', getMatchCardWidget?: { __typename?: 'MatchCardWidget', competitionId?: string | null, tournamentId?: string | null, matchId: string, status?: string | null, startDate?: string | null, roundName?: string | null, resultType?: string | null, firstPosition?: { __typename?: 'ResultWidgetPosition', isServing?: boolean | null, gamePoints?: string | null, isWinner?: boolean | null, players?: Array<{ __typename?: 'ResultWidgetPlayer', nationality?: string | null, name?: string | null, seed?: string | null } | null> | null, score?: Array<{ __typename?: 'ResultWidgetScore', set?: string | null, tie?: string | null, isWinner?: boolean | null } | null> | null } | null, secondPosition?: { __typename?: 'ResultWidgetPosition', isServing?: boolean | null, gamePoints?: string | null, isWinner?: boolean | null, players?: Array<{ __typename?: 'ResultWidgetPlayer', nationality?: string | null, name?: string | null, seed?: string | null } | null> | null, score?: Array<{ __typename?: 'ResultWidgetScore', set?: string | null, tie?: string | null, isWinner?: boolean | null } | null> | null } | null } | null };

export type getRankingWidgetQueryVariables = Exact<{
  tourId: Scalars['ID']['input'];
  type: Scalars['String']['input'];
}>;


export type getRankingWidgetQuery = { __typename?: 'Query', getRankingWidget?: { __typename?: 'RankingWidget', tourId: string, type: string, rankings?: Array<{ __typename?: 'RankingWidgetInfo', nationality?: string | null, playerName?: string | null, points?: string | null, rank?: number | null, trend?: string | null } | null> | null } | null };

export type getResultsCategoriesWidgetQueryVariables = Exact<{
  competitionId: Scalars['ID']['input'];
  type: Scalars['String']['input'];
}>;


export type getResultsCategoriesWidgetQuery = { __typename?: 'Query', getResultsCategoriesWidget?: { __typename?: 'ResultsCategoriesWidget', competitionId: string, type: string, categories?: Array<{ __typename?: 'ResultsCategoriesWidgetInfo', name?: string | null, dates?: Array<string | null> | null } | null> | null, adv?: { __typename?: 'ResultsCategoriesWidgetAdv', link?: string | null, image?: string | null } | null } | null };

export type getResultsContainerWidgetQueryVariables = Exact<{
  competitionId: Scalars['ID']['input'];
  type: Scalars['String']['input'];
}>;


export type getResultsContainerWidgetQuery = { __typename?: 'Query', getResultsContainerWidget?: { __typename?: 'ResultsContainerWidget', competitionId: string, type: string, ssi?: Array<string | null> | null } | null };

export type getResultsWidgetQueryVariables = Exact<{
  tournamentId: Scalars['ID']['input'];
  day: Scalars['ID']['input'];
}>;


export type getResultsWidgetQuery = { __typename?: 'Query', getResultsWidget?: { __typename?: 'ResultsWidget', tournamentId: string, day: string, categoryName?: string | null, date?: string | null, matches?: Array<{ __typename?: 'ResultsWidgetMatch', status?: string | null, startDate?: string | null, roundName?: string | null, resultType?: string | null, firstPosition?: { __typename?: 'ResultWidgetPosition', isServing?: boolean | null, gamePoints?: string | null, isWinner?: boolean | null, players?: Array<{ __typename?: 'ResultWidgetPlayer', nationality?: string | null, name?: string | null, seed?: string | null } | null> | null, score?: Array<{ __typename?: 'ResultWidgetScore', set?: string | null, tie?: string | null, isWinner?: boolean | null } | null> | null } | null, secondPosition?: { __typename?: 'ResultWidgetPosition', isServing?: boolean | null, gamePoints?: string | null, isWinner?: boolean | null, players?: Array<{ __typename?: 'ResultWidgetPlayer', nationality?: string | null, name?: string | null, seed?: string | null } | null> | null, score?: Array<{ __typename?: 'ResultWidgetScore', set?: string | null, tie?: string | null, isWinner?: boolean | null } | null> | null } | null } | null> | null } | null };

export type onUpdateLiveScoreByIdSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onUpdateLiveScoreByIdSubscription = { __typename?: 'Subscription', onUpdateLiveScoreById?: { __typename?: 'LiveScoreWidget', id: string, liveTournaments?: Array<{ __typename?: 'LiveScoreWidgetTournament', competitionId?: string | null, tourYear?: string | null, categoryName?: string | null, tourName?: string | null, tournamentName?: string | null, tournamentType?: string | null, resultsUrl?: string | null, matches?: Array<{ __typename?: 'LiveScoreWidgetMatch', status?: string | null, startDate?: string | null, roundName?: string | null, resultType?: string | null, firstPosition?: { __typename?: 'LiveScoreWidgetPosition', isServing?: boolean | null, gamePoints?: string | null, players?: Array<{ __typename?: 'LiveScoreWidgetPlayer', name?: string | null, nationality?: string | null, seed?: string | null } | null> | null, score?: Array<{ __typename?: 'LiveScoreWidgetScore', isWinner?: boolean | null, set?: string | null, tie?: string | null } | null> | null } | null, secondPosition?: { __typename?: 'LiveScoreWidgetPosition', isServing?: boolean | null, gamePoints?: string | null, players?: Array<{ __typename?: 'LiveScoreWidgetPlayer', name?: string | null, nationality?: string | null, seed?: string | null } | null> | null, score?: Array<{ __typename?: 'LiveScoreWidgetScore', isWinner?: boolean | null, set?: string | null, tie?: string | null } | null> | null } | null } | null> | null } | null> | null, ctaUrls?: { __typename?: 'LiveScoreWidgetCtaUrl', atpCalendarUrl?: string | null, wtaCalendarUrl?: string | null, atpRankingUrl?: string | null, wtaRankingUrl?: string | null } | null } | null };

export type onUpdateMatchCardByIdSubscriptionVariables = Exact<{
  matchId: Scalars['ID']['input'];
}>;


export type onUpdateMatchCardByIdSubscription = { __typename?: 'Subscription', onUpdateMatchCardById?: { __typename?: 'MatchCardWidget', status?: string | null, startDate?: string | null, resultType?: string | null, firstPosition?: { __typename?: 'ResultWidgetPosition', isServing?: boolean | null, gamePoints?: string | null, isWinner?: boolean | null, score?: Array<{ __typename?: 'ResultWidgetScore', set?: string | null, tie?: string | null, isWinner?: boolean | null } | null> | null } | null, secondPosition?: { __typename?: 'ResultWidgetPosition', isServing?: boolean | null, gamePoints?: string | null, isWinner?: boolean | null, score?: Array<{ __typename?: 'ResultWidgetScore', set?: string | null, tie?: string | null, isWinner?: boolean | null } | null> | null } | null } | null };

export type onUpdateRankingWidgetByTourIdSubscriptionVariables = Exact<{
  tourId: Scalars['ID']['input'];
  type: Scalars['String']['input'];
}>;


export type onUpdateRankingWidgetByTourIdSubscription = { __typename?: 'Subscription', onUpdateRankingWidgetByTourId?: { __typename?: 'RankingWidget', tourId: string, type: string, rankings?: Array<{ __typename?: 'RankingWidgetInfo', nationality?: string | null, playerName?: string | null, points?: string | null, rank?: number | null, trend?: string | null } | null> | null } | null };

export type onUpdateResultsWidgetByDaySubscriptionVariables = Exact<{
  tournamentId: Scalars['ID']['input'];
  day: Scalars['ID']['input'];
}>;


export type onUpdateResultsWidgetByDaySubscription = { __typename?: 'Subscription', onUpdateResultsWidgetByDay?: { __typename?: 'ResultsWidget', tournamentId: string, day: string, categoryName?: string | null, date?: string | null, matches?: Array<{ __typename?: 'ResultsWidgetMatch', status?: string | null, startDate?: string | null, roundName?: string | null, resultType?: string | null, firstPosition?: { __typename?: 'ResultWidgetPosition', isServing?: boolean | null, gamePoints?: string | null, isWinner?: boolean | null, players?: Array<{ __typename?: 'ResultWidgetPlayer', nationality?: string | null, name?: string | null, seed?: string | null } | null> | null, score?: Array<{ __typename?: 'ResultWidgetScore', set?: string | null, tie?: string | null, isWinner?: boolean | null } | null> | null } | null, secondPosition?: { __typename?: 'ResultWidgetPosition', isServing?: boolean | null, gamePoints?: string | null, isWinner?: boolean | null, players?: Array<{ __typename?: 'ResultWidgetPlayer', nationality?: string | null, name?: string | null, seed?: string | null } | null> | null, score?: Array<{ __typename?: 'ResultWidgetScore', set?: string | null, tie?: string | null, isWinner?: boolean | null } | null> | null } | null } | null> | null } | null };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: DocumentTypeDecoration<TResult, TVariables>['__apiType'];

  constructor(private value: string, public __meta__?: Record<string, any> | undefined) {
    super(value);
  }

  toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}

export const getCalendarWidgetDocument = new TypedDocumentString(`
    query getCalendarWidget($tourId: ID!, $tournamentFilter: String!) {
  getCalendarWidget(tourId: $tourId, tournamentFilter: $tournamentFilter) {
    tourId
    tournamentFilter
    filterList
    circuitCalendarLink
    tournaments {
      endDate
      startDate
      status
      surface
      tournamentName
      tournamentPlace
      tournamentType
      href
    }
  }
}
    `) as unknown as TypedDocumentString<getCalendarWidgetQuery, getCalendarWidgetQueryVariables>;
export const getLiveScoreWidgetDocument = new TypedDocumentString(`
    query getLiveScoreWidget {
  getLiveScoreWidget(id: "unique") {
    id
    liveTournaments {
      competitionId
      tourYear
      categoryName
      tourName
      tournamentName
      tournamentType
      resultsUrl
      matches {
        status
        startDate
        roundName
        resultType
        firstPosition {
          isServing
          players {
            name
            nationality
            seed
          }
          score {
            isWinner
            set
            tie
          }
          gamePoints
        }
        secondPosition {
          isServing
          players {
            name
            nationality
            seed
          }
          score {
            isWinner
            set
            tie
          }
          gamePoints
        }
      }
    }
    ctaUrls {
      atpCalendarUrl
      wtaCalendarUrl
      atpRankingUrl
      wtaRankingUrl
    }
  }
}
    `) as unknown as TypedDocumentString<getLiveScoreWidgetQuery, getLiveScoreWidgetQueryVariables>;
export const getMatchCardWidgetDocument = new TypedDocumentString(`
    query getMatchCardWidget($matchId: ID!) {
  getMatchCardWidget(matchId: $matchId) {
    competitionId
    tournamentId
    matchId
    status
    startDate
    roundName
    resultType
    firstPosition {
      isServing
      players {
        nationality
        name
        seed
      }
      score {
        set
        tie
        isWinner
      }
      gamePoints
      isWinner
    }
    secondPosition {
      isServing
      players {
        nationality
        name
        seed
      }
      score {
        set
        tie
        isWinner
      }
      gamePoints
      isWinner
    }
  }
}
    `) as unknown as TypedDocumentString<getMatchCardWidgetQuery, getMatchCardWidgetQueryVariables>;
export const getRankingWidgetDocument = new TypedDocumentString(`
    query getRankingWidget($tourId: ID!, $type: String!) {
  getRankingWidget(tourId: $tourId, type: $type) {
    tourId
    type
    rankings {
      nationality
      playerName
      points
      rank
      trend
    }
  }
}
    `) as unknown as TypedDocumentString<getRankingWidgetQuery, getRankingWidgetQueryVariables>;
export const getResultsCategoriesWidgetDocument = new TypedDocumentString(`
    query getResultsCategoriesWidget($competitionId: ID!, $type: String!) {
  getResultsCategoriesWidget(competitionId: $competitionId, type: $type) {
    competitionId
    type
    categories {
      name
      dates
    }
    adv {
      link
      image
    }
  }
}
    `) as unknown as TypedDocumentString<getResultsCategoriesWidgetQuery, getResultsCategoriesWidgetQueryVariables>;
export const getResultsContainerWidgetDocument = new TypedDocumentString(`
    query getResultsContainerWidget($competitionId: ID!, $type: String!) {
  getResultsContainerWidget(competitionId: $competitionId, type: $type) {
    competitionId
    type
    ssi
  }
}
    `) as unknown as TypedDocumentString<getResultsContainerWidgetQuery, getResultsContainerWidgetQueryVariables>;
export const getResultsWidgetDocument = new TypedDocumentString(`
    query getResultsWidget($tournamentId: ID!, $day: ID!) {
  getResultsWidget(tournamentId: $tournamentId, day: $day) {
    tournamentId
    day
    categoryName
    date
    matches {
      status
      startDate
      roundName
      resultType
      firstPosition {
        isServing
        players {
          nationality
          name
          seed
        }
        score {
          set
          tie
          isWinner
        }
        gamePoints
        isWinner
      }
      secondPosition {
        isServing
        players {
          nationality
          name
          seed
        }
        score {
          set
          tie
          isWinner
        }
        gamePoints
        isWinner
      }
    }
  }
}
    `) as unknown as TypedDocumentString<getResultsWidgetQuery, getResultsWidgetQueryVariables>;
export const onUpdateLiveScoreByIdDocument = new TypedDocumentString(`
    subscription onUpdateLiveScoreById {
  onUpdateLiveScoreById(id: "unique") {
    id
    liveTournaments {
      competitionId
      tourYear
      categoryName
      tourName
      tournamentName
      tournamentType
      resultsUrl
      matches {
        status
        startDate
        roundName
        resultType
        firstPosition {
          isServing
          players {
            name
            nationality
            seed
          }
          score {
            isWinner
            set
            tie
          }
          gamePoints
        }
        secondPosition {
          isServing
          players {
            name
            nationality
            seed
          }
          score {
            isWinner
            set
            tie
          }
          gamePoints
        }
      }
    }
    ctaUrls {
      atpCalendarUrl
      wtaCalendarUrl
      atpRankingUrl
      wtaRankingUrl
    }
  }
}
    `) as unknown as TypedDocumentString<onUpdateLiveScoreByIdSubscription, onUpdateLiveScoreByIdSubscriptionVariables>;
export const onUpdateMatchCardByIdDocument = new TypedDocumentString(`
    subscription onUpdateMatchCardById($matchId: ID!) {
  onUpdateMatchCardById(matchId: $matchId) {
    status
    startDate
    resultType
    firstPosition {
      isServing
      score {
        set
        tie
        isWinner
      }
      gamePoints
      isWinner
    }
    secondPosition {
      isServing
      score {
        set
        tie
        isWinner
      }
      gamePoints
      isWinner
    }
  }
}
    `) as unknown as TypedDocumentString<onUpdateMatchCardByIdSubscription, onUpdateMatchCardByIdSubscriptionVariables>;
export const onUpdateRankingWidgetByTourIdDocument = new TypedDocumentString(`
    subscription onUpdateRankingWidgetByTourId($tourId: ID!, $type: String!) {
  onUpdateRankingWidgetByTourId(tourId: $tourId, type: $type) {
    tourId
    type
    rankings {
      nationality
      playerName
      points
      rank
      trend
    }
  }
}
    `) as unknown as TypedDocumentString<onUpdateRankingWidgetByTourIdSubscription, onUpdateRankingWidgetByTourIdSubscriptionVariables>;
export const onUpdateResultsWidgetByDayDocument = new TypedDocumentString(`
    subscription onUpdateResultsWidgetByDay($tournamentId: ID!, $day: ID!) {
  onUpdateResultsWidgetByDay(tournamentId: $tournamentId, day: $day) {
    tournamentId
    day
    categoryName
    date
    matches {
      status
      startDate
      roundName
      resultType
      firstPosition {
        isServing
        players {
          nationality
          name
          seed
        }
        score {
          set
          tie
          isWinner
        }
        gamePoints
        isWinner
      }
      secondPosition {
        isServing
        players {
          nationality
          name
          seed
        }
        score {
          set
          tie
          isWinner
        }
        gamePoints
        isWinner
      }
    }
  }
}
    `) as unknown as TypedDocumentString<onUpdateResultsWidgetByDaySubscription, onUpdateResultsWidgetByDaySubscriptionVariables>;